import React from 'react';
import { useParams } from 'react-router-dom';
import {
  useApiClient, useFetch,
} from '@marageti/z4-lib';
import { Partner, TripMatch, GetParticipantsResponse } from '@marageti/z4-sdk/lib/travel';
import AboutView from './about-view';

const AboutContainer = () => {
  const { tripMatchId } = useParams();
  const apiClient = useApiClient();

  const { data: tripMatch } = useFetch<TripMatch>(apiClient.tripMatchesClient.getTripMatch, [tripMatchId], !!tripMatchId);
  const { data: partner } = useFetch<Partner>(apiClient.partnersClient.getPartner, [tripMatch?.partnerId, { params: { inactive: false } }], !!tripMatch?.partnerId);

  const { data: participants } = useFetch<GetParticipantsResponse>(
    apiClient.conversationsClient.getParticipants,
    [tripMatch?.travelerToPartnerId, { params: { inactive: false } }],
    !!tripMatch?.travelerToPartnerId,
  );

  return (
    <AboutView
      assignedAgentId={tripMatch?.assignedTo}
      partner={partner}
      partnerId={tripMatch?.partnerId}
      participants={participants}
    />
  );
};

export default AboutContainer;
